import React, { useEffect, useRef } from 'react';
import { findGetParameter } from '../../../utils/findGetParameter';
import PuzzleController from '../../../controllers/puzzle/PuzzleController';
import classNames from 'classnames';

const Puzzle = React.forwardRef(function Puzzle(
  { image, isDone, onComplete, onAnimationEnd, puzzleDimension = 3 },
  ref,
) {
  const sceneRef = useRef();

  useEffect(() => {
    const dimension = findGetParameter('dimension') || puzzleDimension;

    const controller = new PuzzleController({
      container: sceneRef.current,
      settings: {
        rows: Number(dimension),
        columns: Number(dimension),
        gap: 3,
        angle: { min: 90, max: 270, delta: 90, targetAngle: 360 },
      },
      image,
      onComplete,
    });

    return () => controller.destroy();
  }, []);

  return (
    <div
      className={classNames('puzzle puzzle_start', {
        puzzle_start: !isDone,
        puzzle_done: isDone,
      })}
      ref={ref}
      onAnimationEnd={onAnimationEnd}
    >
      <div ref={sceneRef} className={'puzzle__scene'}>
        <div className={'puzzle__result'}>
          <img src={image} alt={'puzzle-image'} />
        </div>
      </div>
    </div>
  );
});
export default Puzzle;
Puzzle.propTypes = {};
